var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile"},[_c('v-container',[_c(_vm.templateName,{key:_vm.key,tag:"component",attrs:{"page":_vm.page,"additionalData":_vm.additionalData,"zendeskForm":_vm.zendeskForm}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }